import { render, staticRenderFns } from "./TransactionCreditHistory.vue?vue&type=template&id=473eaf78&"
import script from "./TransactionCreditHistory.vue?vue&type=script&lang=js&"
export * from "./TransactionCreditHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCreditHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports